import { FeatureXs } from './FeatureXs'
import { chunk } from '@/utils/format'
import { Feature } from '@/types/feature'

interface Props {
  features: Feature[]
  column: number
}

export const FeaturesL: React.FC<Props> = ({ features, column }) => {
  const iterateFeatures = chunk(features, column)
  return (
    <div className="mb-10">
      {iterateFeatures.map((iterateFeature) => (
        <div
          className="flex flex-wrap w-full"
          key={`feature-table-${iterateFeature[0]['id']}`}
        >
          <FeatureXs feature={iterateFeature[0]} />
          {iterateFeature[1] && <FeatureXs feature={iterateFeature[1]} />}
          {iterateFeature[2] && <FeatureXs feature={iterateFeature[2]} />}
          {iterateFeature[3] && <FeatureXs feature={iterateFeature[3]} />}
        </div>
      ))}
    </div>
  )
}
